import React from 'react';

export const SvgOverviewEn = (props) => (
  <svg
    overflow='hidden'
    viewBox='0 0 1236 653'
    xmlns='http://www.w3.org/2000/svg'
    width='100%'
    height='100%'
    {...props}
  >
    <defs>
      <clipPath id='Overview_en_svg__a'>
        <path d='M131 1494h1239v655H131z' />
      </clipPath>
    </defs>
    <g
      transform='matrix(.99793 0 0 .99758 -130.94 -1490.6)'
      clipPath='url(#Overview_en_svg__a)'
    >
      <path
        d='M133.5 1604.8c0-59.84 48.503-108.34 108.34-108.34h1017.3c59.84 0 108.34 48.5 108.34 108.34v433.32c0 59.84-48.5 108.34-108.34 108.34H241.84c-59.832 0-108.34-48.5-108.34-108.34z'
        fillRule='evenodd'
        stroke='#4472c4'
        strokeMiterlimit={8}
        strokeWidth={4.583}
      />
    </g>
    <g
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 182.11
      }}
      aria-label='OVERVIEWMAP'
    >
      <path d='M200.37 208.41q0 31.268-17.918 49.713-17.918 18.357-49.537 18.357-31.532 0-49.449-18.357-17.918-18.445-17.918-49.713 0-31.532 17.918-49.801 17.918-18.357 49.449-18.357 31.444 0 49.449 18.357 18.006 18.269 18.006 49.801zm-44.706 33.113q4.919-5.973 7.29-14.053 2.371-8.168 2.371-19.147 0-11.769-2.722-20.026-2.723-8.256-7.115-13.35-4.48-5.27-10.364-7.641-5.797-2.372-12.12-2.372-6.412 0-12.122 2.284-5.62 2.283-10.364 7.553-4.391 4.919-7.202 13.614-2.723 8.608-2.723 20.026 0 11.682 2.635 19.938 2.723 8.169 7.115 13.35 4.391 5.182 10.276 7.642 5.884 2.459 12.384 2.459t12.384-2.46q5.884-2.546 10.276-7.816zM344.68 142.98l-47.693 130.78h-37.768l-47.693-130.78h35.396l31.62 91.872 31.62-91.872zM458.07 273.76h-94.595V142.98h94.595v25.296h-61.043v22.573h56.652v25.296h-56.652v32.322h61.043zM559.69 183.03q0-4.919-2.02-8.432-2.02-3.513-6.939-5.533-3.425-1.406-7.992-1.67-4.568-.35-10.628-.35H519.9v35.22h10.365q8.08 0 13.526-.79 5.445-.79 9.134-3.601 3.513-2.723 5.094-5.973 1.67-3.337 1.67-8.87zm52.611 90.73h-41.193l-35.66-47.956h-15.546v47.956H486.35V142.98h56.564q11.594 0 19.938 1.317 8.344 1.318 15.634 5.71 7.378 4.391 11.682 11.418 4.392 6.938 4.392 17.479 0 14.492-6.763 23.627-6.676 9.134-19.147 15.195zM745.63 142.98l-47.693 130.78h-37.768l-47.693-130.78h35.396l31.62 91.872 31.62-91.872zM835.13 273.76h-76.59v-23.188h21.431v-84.407H758.54v-23.188h76.59v23.188h-21.431v84.407h21.431zM957.22 273.76h-94.595V142.98h94.595v25.296h-61.043v22.573h56.652v25.296h-56.652v32.322h61.043zM1166 142.98l-35.221 130.78h-37.329l-23.451-85.197-22.836 85.197h-37.329l-35.221-130.78h35.221l20.114 90.028 24.066-90.028h33.64l22.924 90.028 21.08-90.028zM546.95 498.61h-33.552v-87.569l-24.242 56.827h-23.275l-24.242-56.827v87.569h-31.795V367.83h39.173l29.424 65.611 29.336-65.611h39.173zM701.19 498.61h-34.869l-9.047-26.437h-48.483l-9.046 26.437h-33.991l48.308-130.78h38.822zm-52.084-50.416-16.073-46.902-16.073 46.902zM827.93 409.11q0 8.783-3.074 17.215-3.074 8.344-8.783 14.053-7.817 7.73-17.48 11.682-9.573 3.952-23.89 3.952h-20.991v42.6h-33.728v-130.78h55.51q12.472 0 20.992 2.195 8.607 2.108 15.195 6.412 7.905 5.182 12.033 13.263 4.216 8.08 4.216 19.41zm-34.869.79q0-5.533-2.986-9.485-2.987-4.04-6.939-5.622-5.27-2.108-10.276-2.283-5.006-.264-13.35-.264h-5.797v39.173h9.662q8.607 0 14.14-1.054 5.622-1.054 9.399-4.216 3.25-2.81 4.655-6.675 1.493-3.952 1.493-9.574z' />
    </g>
  </svg>
);
